import React from "react";


const features = [
  {
    id: 1,
    gifUrl:"/images/gif/projects.png",
    gifAlt:"Find social impact jobs",
    slide: "1/4",
    title: "Find social impact jobs that matter to you",
    subtitle: `Socious uses machine learning to match you with opportunities that resonate with both your social good aspirations and your career goals. 
    We make the experience of contributing to social causes truly fulfilling.`,
    link:"Learn more about AI matching",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#709f02a983e143b1b1b0520eab7a6f47"

  },
  {
    id: 2,
    gifUrl:"/images/gif/hired.png",
    gifAlt:"Safely get hired and paid",
    slide: "2/4",
    title: "Safely get hired & paid",
    subtitle: `Because Socious is based on a blockchain, transactions are highly secure and our fees amongst the lowest in the market.
    We also designed the platform so it's remarkably simple for you to apply to jobs, get hired, and paid, without the hassle you might usually experience.`,
    link:"Learn more about Blockchain",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#15ab48512ddb46fbb7d01cfc8472c693",
  },
  {
    id: 3,
    gifUrl:"/images/gif/impact.png",
    gifAlt:"See your impact grow",
    slide: "3/4",
    title: "See your impact grow",
    subtitle: `With every gig you do, your impact score grows. One contribution after the other you get to see the cumulative impact that you're making, and get recognized as a purpose-driven professional.`,
    link:"Learn more about impact score",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#27759763f0d941788af336561a40d8d7"
  },
  {
    id: 4,
    gifUrl:"/images/gif/payment.png",
    gifAlt:"Earn tokens",
    slide: "4/4",
    title: "Earn tokens",
    subtitle: `Every time you work or volunteer for an impact organization, we reward you with THANK tokens, which are crypto assets with financial and governance utilities on Socious.`,
    link:"Learn more about THANKs",
    linkUrl:"https://www.notion.so/socious/Socious-Whitepaper-58fbe2c106f547898df42e409a00c73e#b78ae33e7f814ffea0e9030d2775db8f"
  }

]

export default features
